export const search = active => ({
  type: 'SEARCHING',
  active
})
